var _rect, _rect2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#DDDDDD",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7442,
    cy: 23.4883,
    r: 2.93023,
    fill: "#CACACA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4884,
    cy: 23.4883,
    r: 2.93023,
    fill: "#CACACA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2326,
    cy: 23.4883,
    r: 2.93023,
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionbtn);
export default __webpack_public_path__ + "static/media/actionbtn.5ac01f068ea3f7c17b71bab75123fe89.svg";
export { ForwardRef as ReactComponent };